import { usePage } from "@inertiajs/react";
import { EProjectTypes } from "app/frontend/constants/enums";

/**
 * This hook returns a project_type from params, disregarding a project_type that may be stored in the session.
 *
 * @returns
 */
export const useParamsProjectType = (): EProjectTypes => {
    return (
        usePage<powerready.IPageProps>()?.props?.params?.project_type as string | undefined
    )?.toUpperCase() as EProjectTypes;
};
